<div style="display: block; height: 100%; width: 100%;">

  <div class="row no-gutters my-2">
    <div class="col-2">
      <button *ngIf="IdBO !== '0' && IdBO !== undefined" type="button" class="q-btn q-main" title="Valider" (click)="SavePosition();"><i class="fas fa-check-circle"></i></button>
      <button *ngIf="IdBO !== '0' && IdBO !== undefined" type="button" class="q-btn q-secondary" title="Ajouter un groupe" (click)="AddConteneur();"><i class="fas fa-plus-circle"></i></button>
    </div>
    <div class="col-10 text-center">
      <select *ngIf="showDdlBo" Select class="w-100 h-100" [placement]="'right'" [isFilter]="true" [placeHolder]="'---Sélectionner un BO---'" [ChangeFirstValue]="true" [height]="34" (outData)="GetDdl($event)">
        <option *ngFor="let Bo of BoModel.ListBo" [value]="Bo.Ident" [selected]="Bo.Ident == IdBO">{{Bo.Info_BOL}} ({{Bo.Code_BOL}})</option>
      </select>
      <h5 *ngIf="IdBO !== '0' && IdBO !== undefined" class="text-center">{{BoModel.StrBo}}</h5>
    </div>
  </div>

  <div class="row no-gutters">
    <div *ngIf="IdBO !== '0' && IdBO !== undefined" class="col-md-2">

      <div class="q-PropList">
        <div class="row no-gutters q-PropList-header">
          <div class="col-9"><h5 class="panel-title">Liste des colonnes</h5></div>
          <div class="col-3"><button type="button" class="q-btn q-secondary" (click)="CreatColumn()"><i class="fas fa-plus-circle"></i></button></div>
          <div class="col-12">
            <input type="text" [(ngModel)]="recherche" class="q-input-border w-100 m-0" placeholder="Rechercher..." />
          </div>
        </div>
        <div class="row no-gutters q-PropList-body" cdkScrollable>
          <div class="col-12">
            <ul id="propList-unbinded"
                cdkDropList
                [cdkDropListData]="BoModel.ListColumnNotUsed"
                [cdkDropListConnectedTo]="connectedTo"
                (cdkDropListDropped)="drop($event)"
                class="list-group">
              <li cdkDrag *ngFor="let Prop of BoModel.ListColumnNotUsed" id="{{Prop.PropId}}" class="q-liProp" [ngClass]="{'q-main': highlightedProp(Prop.PropName + '[' + Prop.PropCol + ']')}">
                <span class="grip"></span>
                <a ngbTooltip="{{Prop.PropName}} [{{Prop.PropCol}}]" #t="ngbTooltip">{{Prop.PropName}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>

    <div *ngIf="IdBO !== '0' && IdBO !== undefined" class="col-md-10">

      <div class="container-fluid">
        <div *ngFor="let row of lstRows; let irow = index" class="row pb-2"
             cdkDropList
             cdkDropListOrientation="horizontal"
             [cdkDropListData]="row"
             [cdkDropListConnectedTo]="rowsConnectedTo"
             (cdkDropListDropped)="DropGroup($event)"
             id="groupList-{{irow}}">
            <ng-container *ngIf="BoModel?.ListProp?.length > 0">
              <ng-container *ngFor="let index of row">
                <ng-container *ngTemplateOutlet="group; context{index:index, Grp:BoModel.ListProp[index]}"></ng-container>
              </ng-container>
            </ng-container>
            <ng-template #group let-i="index" let-Grp="Grp">
              <div cdkDrag [cdkDragData]="i" class="col-12 col-md group-container">
                <div class="drag-placeholder" *cdkDragPlaceholder></div>
                <div class="q-boCard">
                  <div class="q-boCard-header">
                    <input id="IdTitreBox{{i}}" type="text" class="form-control" placeholder="nom du bloc" [(ngModel)]="Grp.PropGroupName" />
                    <select *ngIf="listTemplate.length > 0" class="q-main-select q-bo-select q-bo-wrap templateSelect" [(ngModel)]="Grp.PropGroupTemplate">
                      <option value="">-------------</option>
                      <option *ngFor="let template of listTemplate" value="{{template.templateComponent}}" title="{{template.templateToolTips}}">{{template.templateName}}</option>
                    </select>
                    <div *ngIf="Grp.PropGroupTemplate" class="templateSize W">
                      <input id="IdTitreBoxX{{i}}" type="text" class="form-control" placeholder="Largeur" [(ngModel)]="Grp.PropGroupTemplateX" />
                    </div>
                    <div *ngIf="Grp.PropGroupTemplate" class="templateSize H">
                      <input id="IdTitreBoxY{{i}}" type="text" class="form-control" placeholder="Hauteur" [(ngModel)]="Grp.PropGroupTemplateY" />
                    </div>
                  </div>
                  <div class="q-boCard-body" cdkScrollable [ngClass]="{'q-boCard-body-template': listTemplate.length > 0 && !Grp.PropGroupTemplate,'q-boCard-body-template-selected': listTemplate.length > 0 && Grp.PropGroupTemplate}">
                    <ul class="list-group bo-card" id="propList-{{i}}"
                        cdkDropList [cdkDropListData]="Grp.PropList" [cdkDropListConnectedTo]="connectedTo"
                        (cdkDropListDropped)="drop($event)">
                      <ng-container *ngFor="let Prop of Grp.PropList">
                        <li cdkDrag *ngIf="Prop.PropName" class="q-liProp row no-gutters" [ngClass]="{'q-main': highlightedProp(Prop.PropName + '[' + Prop.PropCol + ']')}">
                          <span class="grip col-1"></span>
                          <a ngbTooltip="{{Prop.PropName}} [{{Prop.PropCol}}]" class="col-10" #t="ngbTooltip">{{Prop.PropName}}</a>
                          <button type="button" class="btn  btn-default col-1" (click)="Openconfig(Prop)">
                            <i class="fas fa-cogs"></i>
                          </button>
                        </li>
                      </ng-container>
                    </ul>
                    <!-- Modal -->
                    <div id="myModal" class="card q-popup-addColumn" #ModalCreateColumn>
                      <!-- Modal content -->
                      <div class="card-header">
                        <span class="close" onclick="document.getElementById('myModal').style.display = 'none'">&times;</span>
                        <b>Création d'une nouvelle colonne</b>
                      </div>
                      <div class="card-body">
                        <form>
                          <label class="TableLabel">Type : </label>
                          <!--<select class="form-control" id="ddlbo" required="required" (change)="GetDdlColType($event.target.value)">-->
                          <select class="form-control" required="required" (change)="GetDdlColType($event.target.value)">
                            <option value="" selected disabled>- - - - -</option>
                            <!--MODE ADMIN-->
                            <option ng-if="IsSuperUser" value="{{TypeCol.VastrBOV}}" *ngFor="let TypeCol of BoModel.ListTypeCol">{{TypeCol.Info_BOV}}</option>
                            <!--MODE USER-->
                            <option ng-if="!IsSuperUser" value="DATETIME">DATE</option>
                            <option ng-if="!IsSuperUser" value="NVARCHAR">TEXTE</option>
                            <option ng-if="!IsSuperUser" value="MONEY">MONETAIRE</option>
                            <option ng-if="!IsSuperUser" value="INT">NOMBRE ENTIER</option>
                            <option ng-if="!IsSuperUser" value="BOOLEAN">BOOLÉEN</option>
                          </select>
                          <br>
                          <label class="TableLabel">Code colonne  : </label>
                          <input class="form-control" type="text" required="required" [(ngModel)]="BoModel.ColumnName" maxlength="{{NomColMaxLength}}" name="NomColonne" placeholder="Identifiant de la colonne en {{NomColMaxLength}} lettres">
                          <br>
                          <label class="TableLabel">Nom de la colonne : </label>
                          <input class="form-control" type="text" required="required" [(ngModel)]="BoModel.ColumnInfo" name="InfoColonne" placeholder="Nom d'affichage de la colonne">
                          <br>
                          <!--<button type="submit" id="IdBtnSave0" class="q-btn q-main" title="Valider" (click)="AddColumn();"><i class="fa fa-check-circle"></i></button>-->
                          <button type="submit" class="q-btn q-main" title="Valider" (click)="AddColumn();"><i class="fa fa-check-circle"></i></button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

              </div>


            </ng-template>
        </div>
      </div>

    </div>
  </div>

</div>

<!--#region BO PROPS Administration -->

<q-dragmodal [id]="propDragModalId" [options]="propDragOptions">

  <div class="content-fluid" *ngIf="dragContentShow">
    <div class="row">
      <div class="col-12">
        <q-adminpropdata [options]="propOption"></q-adminpropdata>
      </div>
    </div>
  </div>

</q-dragmodal>

<!--#endregion BO PROPS Administration -->
